import { z } from "zod";

export const zAttrSwitch = z.object({
  editor: z.literal("Switch"),
});

export type ZAttrSwitch = z.infer<typeof zAttrSwitch>;
